export default __webpack_public_path__ + "static/media/wasteManagementCase.8460f380.jpg";